<footer class="custom-footer2">
  <div class="footer-content">
    <span class="copyright">© {{ companyName }}. All Rights Reserved</span>
    <span class="separator">|</span>
    <span class="version">Version {{ version }}@if (qaCycle) {<span>{{ qaCycle }}</span>}</span>
    <span class="separator">|</span>
    <span class="project-code">PP-ELI-PHL-0808 / March 2026</span>
  </div>
</footer>
